// DebugIdBox.tsx
import React from "react"
import { View, TouchableOpacity } from "react-native"
import { H5, Tiny } from "@/components/standard/BFText"
import { showErrorToast } from "@/components/toasts/AppToast"
import { useUser } from "@/queries/user"

const DebugIdBox = () => {
  const { data: userData } = useUser()
  const { id: userId } = userData?.me || {}

  const copyToClipboard = () => {
    // Once we're ready to update the binary and/or implement a clipboard copying feature we can add this to the project
    showErrorToast({
      title: "Notice",
      message: "Clipboard copying is not supported yet on Native platforms.",
    })
  }

  return (
    <View className="flex flex-col w-full border rounded border-light-grey p-4 mb-2">
      <H5>User Information:</H5>
      <TouchableOpacity testID={"copy-to-clipboard"} onPress={copyToClipboard}>
        <Tiny className="text-blue-500 underline">{`User ID: ${userId || "N/A"}`}</Tiny>
      </TouchableOpacity>
    </View>
  )
}

export default DebugIdBox
